import React from 'react'
import BusinessEntities from './BusinessEntities/BusinessEntities'
import MetaData from './MetaData/MetaData'
import TokenDialog from './TokenDialog/TokenDialog'
import useRefreshToken from './useRefreshToken'
import { BI_DASHBOARD_URL } from '../../Constants/Constants'
import { CLIENT_PERMISSION } from '../../../features/clientUsers/clientAccess'
import { useSubscriptionAccess } from '../../../features/clientUsers/useClientAccess'

const Details = ({ connector, businessEntitiesSource, businessEntitiesTarget }) => {
    const refreshToken = useRefreshToken(connector.clientId)
    const { can } = useSubscriptionAccess(connector.subscriptionId)
    const { instance } = connector

    return (
        <>
            <div className="col-lg-8">
                <div className="card mndesc">
                    <BusinessEntities
                        connectorId={connector.connectorId}
                        businessEntitiesSource={businessEntitiesSource}
                        businessEntitiesTarget={businessEntitiesTarget}
                        sourceShortName={connector.source.shortName}
                        targetShortName={connector.target.shortName}
                    />
                </div>
            </div>

            <div className="col-lg-4">
                <div className="card mndesc">
                    <MetaData
                        connector={connector}
                        canViewToken={can(CLIENT_PERMISSION.TOKEN_READ)}
                        onViewToken={refreshToken.open}
                        isBiDashboardEnable={Boolean(instance.isBiDashboardEnable)}
                        biDashboardUrl={`${BI_DASHBOARD_URL}/dashboard/bi/${instance.id}`}
                    />
                </div>
            </div>

            <TokenDialog
                isOpen={refreshToken.isOpen}
                canRotate={can(CLIENT_PERMISSION.TOKEN_ROTATE)}
                token={refreshToken.token}
                hasToken={refreshToken.hasToken}
                isLoading={refreshToken.isLoading}
                isGenerating={refreshToken.isGenerating}
                isDeleting={refreshToken.isDeleting}
                isConfirmingDelete={refreshToken.isConfirmingDelete}
                onClose={refreshToken.close}
                onCopy={refreshToken.copy}
                onRequestDelete={refreshToken.requestDelete}
                onCancelDelete={refreshToken.cancelDelete}
                onConfirmDelete={refreshToken.confirmDelete}
                onGenerate={refreshToken.generate}
            />
        </>
    )
}

export default Details
